'use client';

import { motion } from 'framer-motion';
import Link from 'next/link';
import { ArrowRight, CalendarDays } from 'lucide-react';

export default function CTA() {
  return (
    <section className="cta-section">
      <div className="section-container">
        <motion.div
          className="cta-banner"
          initial={{ opacity: 0, scale: 0.92 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        >
          <div className="cta-orb cta-orb-1" />
          <div className="cta-orb cta-orb-2" />
          <div className="cta-grid-overlay" />

          <motion.div
            className="cta-content"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <span className="cta-eyebrow">Ready to launch?</span>
            <h2 className="cta-title">Have a project in mind?</h2>
            <p className="cta-subtitle">
              Let&apos;s turn your idea into a polished digital experience. Whether it&apos;s a quick
              consultation or a full-scale build, I&apos;m here to help.
            </p>

            <div className="cta-buttons">
              <Link href="/contact" className="cta-btn cta-btn-primary">
                Start a Project
                <ArrowRight size={18} />
              </Link>
              <Link href="/appointment" className="cta-btn cta-btn-outline">
                <CalendarDays size={18} />
                Book a Call
              </Link>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
